import styled from "styled-components";

export const PageBreakAfterDiv = styled.div`
    @media print {
        page-break-after: always;
    }
`;
